import { convertDigitToProperFormat } from '../../../../../../utils/number';

export default {
  save: 'ذخیره',
  noItemSelected: 'موردی انتخاب نشده',
  addAllQuestions: 'انتخاب همه',
  questions: (title: string) => {
    return `سوالات «${title}»`;
  },
  thereIsNoItem: 'سوالی یافت نشد',
  added: 'اضافه شده',
  add(length: number) {
    return `اضافه کردن ${convertDigitToProperFormat(length)} سوال به پرسشنامه`;
  },
};
